export enum ORDER_STATUS {
  CANCELED = 'CANCELED',
  FULFILLED = 'FULFILLED',
  NEW_ORDER = 'NEW_ORDER',
}
